<template>
  <div class="cer-risk">
    <canvas class="gk-chart" ref="pieChart1" width="600" height="450"></canvas>

    <div class="info2">
      <ul v-if="gdb3">
        <li class="cer_equal">
          <!--<i class="rect"></i> -->
          风险与{{ child === 1 ? '孩子' : '您' }}相同的人群占: <span>{{ data.equal }}%</span>
        </li>
        <li class="cer_low">
          <!--<i class="rect"></i>-->
          风险比{{ child === 1 ? '孩子' : '您' }}低的人群占: <span>{{ data.low }}%</span>
        </li>
        <li class="cer_high">
          <!--<i class="rect"></i> -->
          风险比{{ child === 1 ? '孩子' : '您' }}高的人群占比: <span>{{ data.high }}%</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data: function () {
    return {
      child: this.util.getLS(this.api.child), // 是否是儿童版报告
      gdb3: false,
      gdb2: false,
      multiple: 3 // 3倍缩放， 使 canvas 更清晰
    }
  },
  methods: {
    drawPieChart1 () {
      let multiple = this.multiple
      let pieChart1 = this.$refs.pieChart1
      let ctx = pieChart1.getContext('2d')
      let cx = pieChart1.width / 2
      let cy = pieChart1.height / 2
      let cr = 70 * multiple
      let sicknessRate = this.sicknessRate
      let startDeg = 0 // 存放每次的起始角度
      let color = ['#00AEFF', '#E370ED', '#FF6A00']
      ctx.font = (14 * multiple) + 'px Arial'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      let endDegs = []
      for (let i = 0, len = sicknessRate.length; i < len; i++) {
        ctx.fillStyle = color[i]
        let endDeg = sicknessRate[i] / 100 * 2 * Math.PI
        endDegs.push(endDeg)
        ctx.beginPath()
        ctx.moveTo(cx, cy)
        ctx.arc(cx, cy, cr, startDeg, startDeg + endDeg, false)
        ctx.fill()
        startDeg = startDeg + endDeg
      }
    },
    clear () {
      let pieChart1 = this.$refs.pieChart1
      let ctx1 = pieChart1.getContext('2d')
      ctx1.beginPath()
      ctx1.clearRect(0, 0, 600, 450)
    }
  },
  computed: {
    sicknessRate () {
      if (this.gdb3) {
        return [this.data.high, this.data.equal, this.data.low] // 顺序是 高 相同 低
      } else {
        return [this.data.up_rate, this.data.same_rate, this.data.low_rate] // 顺序是 高 相同 低
      }
    }
  },
  watch: {
    data: function () {
      this.clear()
      this.drawPieChart1()
    }
  },
  mounted () {
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true
      this.drawPieChart1()
    } else {
      this.gdb2 = true
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/functions";
  .cer-risk {
    color: #000;
    .title {
      padding-left: pxToRem(40px);
      padding-top: pxToRem(26px);
      color: #AAA9AA;
      font-weight: normal;
    }
    .info2 {
      font-size: pxToRem(25px);
      font-weight: 300;
      letter-spacing: 1px;
      text-align: center;
      ul {
        display: inline-block;
        margin-top: pxToRem(120px);
        text-align: left;
      }
      li {
        margin-top: pxToRem(20px);
      }
      /*padding: 2em 0 2em pxToRem(100px);*/
      .cer_low {
        .rect {
          background: #FB7376;
        }
        span {
          color: #FF6A00;
        }
      }
      .cer_equal {
        .rect {
          background: #FEB500;
        }
        span {
          color: #E370ED;
        }
      }
      .cer_high {
        .rect {
          background-color: #00C0EE;
        }
        span {
          color: #00AEFF;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CerRisk.vue